module.exports = __webpack_public_path__ + "img/relatus_green_logo_horizontal.65b6b56f.svg";